import { defineNuxtPlugin } from '#imports'
import VueScrollTo from 'vue-scrollto'

export default defineNuxtPlugin({
  name: 'vue scroll to',
  enforce: 'post',
  parallel: true,
  setup(nuxtApp) {
    const { vueApp } = nuxtApp

    vueApp.use(VueScrollTo)
  },
})
